<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <!-- <a-tabs @change="callback" :activeKey="active" type="card"> -->
    <!-- <a-tab-pane :key="1" tab="基本信息"> -->
    <div v-if="form && form.id">
      <a-descriptions :column="4" title="基本信息" class="full-width-descriptions">
        <!-- <a-descriptions-item label="联系电话"> {{ form.mobile }}</a-descriptions-item> -->
        <a-descriptions-item label="店铺名称"> {{ form.shopName }} </a-descriptions-item>
        <a-descriptions-item label="用户手机号"> {{ form.userPhone }} </a-descriptions-item>
        <a-descriptions-item label="联系名称"> {{ form.name }} </a-descriptions-item>
        <a-descriptions-item label="联系电话"> {{ form.phone }} </a-descriptions-item>
        <a-descriptions-item label="等级"> {{ form.level }} </a-descriptions-item>
        <a-descriptions-item label="折扣"> {{ form.discount }} </a-descriptions-item>
        <a-descriptions-item label="申请说明"> {{ form.applyForVal }} </a-descriptions-item>
        <a-descriptions-item label="地址"> {{ form.address }} </a-descriptions-item>
        <!-- <a-descriptions-item label="用户手机号"> {{ form.userPhone }} </a-descriptions-item> -->
        <a-descriptions-item label="状态">
          <a-tag color="green" v-if="form.status == 1"> 正常 </a-tag>
          <a-tag color="red" v-if="form.status == 0">禁用</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="审核人员"> {{ form.reviewerUserName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="审核状态">
          <a-tag color="green" v-if="form.reviewerStatus == 1"> 通过 </a-tag>
          <a-tag color="red" v-if="form.reviewerStatus == 0">待审核</a-tag>
          <a-tag color="red" v-if="form.reviewerStatus == 2">失败</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="审核时间"> {{ form.reviewerTime }}</a-descriptions-item>
        <a-descriptions-item label="备注"> {{ form.remark }}</a-descriptions-item>
        <a-descriptions-item label="创建时间"> {{ form.createTime }}</a-descriptions-item>
      </a-descriptions>
    </div>
    <!-- </a-tab-pane> -->
    <!-- <a-tab-pane :key="3" tab="商品信息" v-if="hasPermission('system:jing:three')">
        <Goods :isOperate="false" :categoryId="form.id" v-if="form.id"></Goods>
      </a-tab-pane> -->
    <!-- </a-tabs> -->
  </a-drawer>
</template>
<script>
import { getObj } from '@/api/declaration/customer'
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// import Regin from '../../pressure/region'
// import Sms from '../../pressure/sms'
// import PointsRule from '../../pressure/pointsRule'
import Goods from '../../../pressure/goods/index.vue'
// import Dispatch from '../../../pressure/dispatch/index.vue'
// import User from '../../system/user/index'
// import tenantTwo from '../../../system/tenant/tenantTwo.vue'
export default {
  name: 'Post',
  components: { Goods },
  data() {
    return {
      visible: false,
      form: {},
      dataForm: {},
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      options: [
        { id: 1, name: '周一' },
        { id: 2, name: '周二' },
        { id: 3, name: '周三' },
        { id: 4, name: '周四' },
        { id: 5, name: '周五' },
        { id: 6, name: '周六' },
        { id: 7, name: '周日' },
      ],
      evaluationOptions: [
        { value: 1, label: '商品评价' },
        { value: 2, label: '店家服务态度' },
        { value: 3, label: '安装评价' },
        { value: 4, label: '验收评价' },
        { value: 5, label: '服务评价' },
        { value: 6, label: '回访评价' },
        { value: 7, label: '服务人员形象评价' },
        { value: 8, label: '对服务流程讲解' },
        { value: 9, label: '管路检查及丝堵检查' },
        { value: 10, label: '管道真伪查询' },
        { value: 11, label: '打压试验' },
        { value: 12, label: ' 检查管路漏水、虚焊、漏焊' },
        { value: 13, label: ' 是否张贴关闭总阀及温馨提示' },
        { value: 14, label: '拍摄全景管路图' },
      ],
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
    }
  },
  filters: {},
  created() {
    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    init(e, index) {
      this.active = index
      this.$forceUpdate()
      getObj(e.id).then((res) => {
        this.form = res.data
        // this.dataForm = e
      })
      this.visible = true
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60) // 计算小时
      const remainingMinutes = minutes % 60 // 计算剩余的分钟
      return `${hours > 10 ? hours : '0' + hours}:${remainingMinutes > 10 ? remainingMinutes : '0' + remainingMinutes}`
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage

      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      const that = this
      that.visible = false
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      this.active = e
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
<style lang="less">
img {
  width: 80px;
  height: 80px;
}
.full-width-descriptions {
  width: 100% !important;
  // background: red;
  box-sizing: border-box; /* 确保包含内边距和边框 */
}
.ant-descriptions-item {
  width: 25%;
  // background: red;
}
.ant-descriptions-item-label {
  width: 100px;
  // background: red;
  text-align: right;
}
</style>
